import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { WorkPackages, WorkPackagesCollection } from './workPackages.types';

const useSelectedWorkPackage = (workPackageId: string) => {
  const getWorkPackageQuery = useCallback(
    (collection: WorkPackagesCollection) => {
      return collection?.find({ selector: { workPackageId } });
    },
    [workPackageId],
  );

  const { result, isFetching: isWorkPackageDetailLoading } = useRxData<WorkPackages>(
    RxdbCollectionName.WORK_PACKAGES,
    getWorkPackageQuery,
    { json: true },
  );

  return { selectedWorkPackage: result[0], isWorkPackageDetailLoading };
};

export default useSelectedWorkPackage;
